<template>
  <div class="min-w-150">
    <!-- is building owner -->
    <b-card v-if="mandate.representant_owner_id" class="text-left">
      {{ getPersonNameAndGender({ personId: mandate.representant_owner_id }) }}

      <div>
        <b-badge> {{ getTotalMandateTantiemesChargeGenerale(mandate.id) }} </b-badge>
        <b-badge
          v-if="getReducedMandateTantiemesChargeGenerale(mandate.id)"
          class="ml-1"
          variant="warning"
        >
          {{ getReducedMandateTantiemesChargeGenerale(mandate.id) }}</b-badge
        >
      </div>

      <appParticipantVotingRulesIndicator
        v-if="votingLimitRules.votingLimitIsActive"
        class="my-1"
        :nb-of-represented-mandates="nbOfRepresentedMandates"
        :nb-of-represented-tantiemes="nbOfRepresentedTantiemes"
      />

      <font-awesome-icon
        v-if="
          representedMandates.length == 1 &&
          mandate.resolution_votes.length == 0 &&
          !hasMandatesRepresented
        "
        class="icon-click text-danger delete-participant-button"
        icon="trash-alt"
        @click="REMOVE_MANDATE(mandate)"
      />

      <div v-if="hasMandatesEvents">
        <font-awesome-icon
          class="icon-click text-dark"
          icon="calendar"
          @click="openModalChangeMandateDates"
        />
        <b-modal
          v-if="showModalChangeMandateDates"
          :id="`modal-change-mandate-dates-${mandate.id}`"
          size="lg"
          hide-footer
          centered
          :visible="true"
          @hide="closeModalChangeMandateDates"
        >
          <modalChangeMandateDates :mandate-id="mandate.id" />
        </b-modal>
      </div>
    </b-card>

    <!-- is contact -->
    <b-card v-else-if="mandate.representant_contact_id" class="text-left bg-light">
      <div>
        {{
          getPersonNameAndGender({
            personId: mandate.representant_contact_id,
            personType: "contact",
          })
        }}
      </div>
      <appParticipantVotingRulesIndicator
        v-if="votingLimitRules.votingLimitIsActive"
        class="my-1"
        :nb-of-represented-mandates="nbOfRepresentedMandates"
        :nb-of-represented-tantiemes="nbOfRepresentedTantiemes"
      />
    </b-card>
  </div>
</template>

<script>
import MeetingORM from "@/store/orm-axios/models/Meeting";

import tablesMixins from "@/mixins/tables";
import meetingDetailsMixin from "@/mixins/meeting-details";

import appParticipantVotingRulesIndicator from "./ParticipantVotingRulesIndicator";
import modalChangeMandateDates from "@/components/b-table-components/modals/ChangeMandateDates";

import { meetingMinutesNames } from "@/constants/meeting.js";

export default {
  components: {
    appParticipantVotingRulesIndicator,
    modalChangeMandateDates,
  },
  mixins: [tablesMixins, meetingDetailsMixin],
  props: {
    mandate: {
      type: Object,
      default: () => {
        return {};
      },
    },
    presenceMandates: {
      type: Array,
      default: () => {
        return [];
      },
    },
    isVideoCase: {
      type: Boolean,
      default: false,
    },
    isDummyVideoCase: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showModalChangeMandateDates: false,
    };
  },
  computed: {
    representedMandates() {
      return this.$_.filter(this.presenceMandates, item => {
        if (this.mandate.representant_owner_id)
          return item.representant_owner_id == this.mandate.representant_owner_id;
        else if (this.mandate.representant_contact_id)
          return item.representant_contact_id == this.mandate.representant_contact_id;
      });
    },
    meeting() {
      return MeetingORM.getters("getById")(this.$route.params.id);
    },

    nbOfRepresentedMandates() {
      var nbOfRepresentedMandates = this.representedMandates.length;
      var participantIsOwner = !!this.$_.find(this.representedMandates, item => {
        return item.building_owner_id == item.representant_owner_id;
      });
      if (participantIsOwner) nbOfRepresentedMandates--;
      return nbOfRepresentedMandates;
    },
    nbOfRepresentedTantiemes() {
      return this.getMandatesTantiemesChargeGenerale(this.representedMandates, true);
    },

    hasMandatesRepresented() {
      if (!this.meeting) return false;

      var hasMandatesRepresented = this.$_.find(this.meeting.minutes, minute => {
        return (
          (minute.event == meetingMinutesNames.mandate_added &&
            (minute.representant_id == this.mandate.representant_owner_id ||
              minute.representant_id == this.mandate.representant_contact_id)) ||
          (minute.event == meetingMinutesNames.mandate_moved &&
            (minute.move_from_representant_id == this.mandate.representant_owner_id ||
              minute.move_from_representant_id == this.mandate.representant_contact_id)) ||
          (minute.event == meetingMinutesNames.mandate_left &&
            (minute.representant_id == this.mandate.representant_owner_id ||
              minute.representant_id == this.mandate.representant_contact_id))
        );
      });

      return !!hasMandatesRepresented;
    },
    hasMandatesEvents() {
      if (!this.meeting) return false;
      var hasMandatesEvents = this.$_.find(this.meeting.minutes, minute => {
        return (
          (minute.event == meetingMinutesNames.mandate_added ||
            minute.event == meetingMinutesNames.mandate_moved ||
            minute.event == meetingMinutesNames.mandate_left) &&
          minute.mandate_id == this.mandate.id
        );
      });
      return !!hasMandatesEvents;
    },
  },
  methods: {
    openModalChangeMandateDates() {
      this.showModalChangeMandateDates = true;
    },
    closeModalChangeMandateDates() {
      this.showModalChangeMandateDates = false;
    },
  },
};
</script>
